import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-report-copy-confirm",
  styleUrls: ["./inspection-report-edit-text-copy-confirm-dialog.component.scss"],
  templateUrl: "./inspection-report-edit-text-copy-confirm-dialog.component.html",
  standalone: false
})
export class ReportCopyConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ReportCopyConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
